import { Component, Inject, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../../../../notification/shared/notification.service'
import { Client } from '../../../../../shared/client/client'
import { Lingerie, TypeLingerie } from '../../shared/lingerie'
import { LingerieService } from '../../shared/lingerie.service'

@Component({
  selector: 'app-update-lingerie-modal',
  templateUrl: './update-lingerie-modal.component.html',
  styleUrls: [
    './update-lingerie-modal.component.scss'
  ]
})
export class UpdateLingerieModalComponent implements OnInit {

  public form = new UntypedFormGroup({
    nom: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    activated: new UntypedFormControl(true, [])
  })

  public types: TypeLingerie[] = null
  client: Client
  lingerie: Lingerie
  selection: TypeLingerie[]

  constructor(
    public dialogRef: MatDialogRef<UpdateLingerieModalComponent>,
    private route: ActivatedRoute,
    private lingerieService: LingerieService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: { client: Client, lingerie: Lingerie },
  ) { }

  ngOnInit(): void {
    this.client = this.data.client
    this.lingerie = this.data.lingerie
    this.form.get('nom').setValue(this.lingerie.libelle)
    this.form.get('activated').setValue(this.lingerie.activated)

    this.lingerieService.getClientTypesLingeries(this.client).subscribe((types) => {
      types.sort((a, b) => {
        if (a.libelle == "Autre") return 1
        if (b.libelle == "Autre") return -1
        if (a.libelle < b.libelle) return -1
        if (a.libelle > b.libelle) return 1
        if (a.libelle == b.libelle) return 0
      })
      this.types = types

      if (types.length == 1) {
        this.form.get('type').setValue([types[0].id])
        this.form.controls['type'].disable()
      } else {
        this.form.controls['type'].enable()
        let initTypes = []
        this.lingerie.types.forEach((value) => {
          initTypes.push(value.id)
        })
        this.form.get('type').setValue(initTypes)
      }

    })
  }

  onSubmit() {
    if (this.form.valid) {
      let newTypes = []
      if (this.types.length == 1) {
        newTypes.push(this.types[0])
      } else {
        this.form.value.type.forEach(typeId => {
          newTypes.push(this.types.find(value => value.id == typeId))
        })
      }

      let datas = { libelle: this.form.value.nom, type: newTypes, activated: this.form.value.activated }
      this.lingerieService.updateLingerie(this.lingerie.id, datas).subscribe((lingerie) => {
        this.notificationService.notif("Lingerie n°" + this.lingerie.id + " modifiée", "notif")
        this.dialogRef.close(lingerie)
      })
    }
  }

  refuse() {
    this.dialogRef.close(false)
  }

  activated() {
    return true
  }
}
